export default __webpack_public_path__ + "static/media/image-candidato.f04fe46c.png";